import React, { useEffect, useState } from "react";
import { ResponsiveContainer } from "recharts";

export default function ClientResponsiveContainer({ children, ...props }) {
    const [mounted, setMounted] = useState(false);

    useEffect(() => {
        setMounted(true);
    }, []);

    if (!mounted) {
        return null;
    }

    return (
        <ResponsiveContainer width="100%" height="100%" minWidth={0} {...props}>
            {children}
        </ResponsiveContainer>
    );
}
